import React, {Fragment} from 'react'

import { Route, Switch, Router, Redirect } from 'react-router-dom';

import history from "./history";

import withTracker from './components/GA/Tracker';

import {toast, ToastContainer} from "react-toastify";

import { Reservation, Order, PaymentRedirect, UponPickupPaymentRedirect, Summary, OrderSummary, Feedback } from "./DynamicImports";

import 'styling/semantic.less';
import "./barestho.css";
import "./baresthoVars.css";
import "react-toastify/dist/ReactToastify.css";


// TODO: Add cancel and contact pages
const App = () => (
    <Fragment>
        <ToastContainer position={toast.POSITION.TOP_CENTER} hideProgressBar={true} autoClose={8000} />
        <Router history={ history }>
            <Switch>
                {/* <Route exact path="/" component={withTracker(Reservation)}/> */}
                <Route exact path="/shop" component={withTracker(Order)}/>
                <Route exact path="/shop/redirect" component={withTracker(PaymentRedirect)}/>
                <Route exact path="/shop/summary" component={withTracker(OrderSummary)}/>
                <Route exact path="/shop/upon-pickup-redirect" component={withTracker(UponPickupPaymentRedirect)}/>
                {/* <Route exact path="/summary" component={withTracker(Summary)}/>
                <Route exact path="/feedback" component={withTracker(Feedback)} /> */}
                <Route exact path="*" component={() => <Redirect to="/shop" />}/>
            </Switch>
        </Router>
    </Fragment>
);

export default App



// WEBPACK FOOTER //
// ./src/App.js